"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subtractPolys = subtractPolys;
var _vector = require("./vector");
// TODO: If you change this to import, ClipperLib is an Object, which creates ts errors
const {
  ClipperLib
} = require('./clipper.js');
/**
 * Returns an array of polys obtained by subtracting a narrow band around each open poly from the given closed polys.
 * @param closedPolys The closed polys to subtract from. If the first and last points are repeated, the last point will
 * be removed before processing.
 * @param openPolys The open polys to subtract. The first and last point should not be repeated.
 * @param width The width of the narrow band to subtract around each open cut poly, in native part units. Default is
 * 0.02.
 */
function subtractPolys(closedPolys, openPolys, width = 0.02) {
  // Add all of the closed polys to the clipper object

  // Outset all of the open polys to create narrow closed paths

  const miterLimit = 1;
  const curveTolerance = 0.001;
  const clipperOffsetOpenCut = new ClipperLib.ClipperOffset(miterLimit, curveTolerance);
  let pathsOpenCut = openPolys.map(c => c.map(toClipper));
  clipperOffsetOpenCut.AddPaths(pathsOpenCut, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etOpenRound);
  const pathsNarrowClosed = new ClipperLib.Paths();
  clipperOffsetOpenCut.Execute(pathsNarrowClosed, width / 2);

  // Subtract the narrow closed paths from the part

  const clipperSubtractNarrowClosed = new ClipperLib.Clipper();

  // Add every closed poly to the clipper as a subject
  for (let c of closedPolys) {
    const clipPoly = c.map(toClipper);
    if ((0, _vector.norm2)((0, _vector.sub)(c[0], c[c.length - 1])) < 1e-12) {
      clipPoly.splice(0, 1); // If the first and last point was repeated, remove the last point
    }

    clipperSubtractNarrowClosed.AddPath(clipPoly, ClipperLib.PolyType.ptSubject, true);
  }
  clipperSubtractNarrowClosed.AddPaths(pathsNarrowClosed, ClipperLib.PolyType.ptClip, true);
  let pathsSubtractResult = new ClipperLib.Paths();
  clipperSubtractNarrowClosed.Execute(ClipperLib.ClipType.ctDifference, pathsSubtractResult);
  return pathsSubtractResult.map(path => path.map(fromClipper));
}
function toClipper(pt) {
  return {
    X: pt.x,
    Y: pt.y
  };
}
function fromClipper(pt) {
  return {
    x: pt.X,
    y: pt.Y
  };
}